import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ScrollToTop } from './components/ScrollToTop';

// Lazy loaded pages for performance optimization
const Home = lazy(() => import('./pages/Home').then(module => ({ default: module.Home })));
const About = lazy(() => import('./pages/About').then(module => ({ default: module.About })));
const Companies = lazy(() => import('./pages/Companies').then(module => ({ default: module.Companies })));
const Contact = lazy(() => import('./pages/Contact').then(module => ({ default: module.Contact })));
const NotFound = lazy(() => import('./pages/NotFound').then(module => ({ default: module.NotFound })));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy').then(module => ({ default: module.PrivacyPolicy })));
const TermsAndConditions = lazy(() => import('./pages/TermsAndConditions').then(module => ({ default: module.TermsAndConditions })));

// Sub-companies
const KalyanAgencies = lazy(() => import('./pages/sub-companies/KalyanAgencies').then(module => ({ default: module.KalyanAgencies })));
const FrostellaPickles = lazy(() => import('./pages/sub-companies/FrostellaPickles').then(module => ({ default: module.FrostellaPickles })));
const FrostellaDesserts = lazy(() => import('./pages/sub-companies/FrostellaDesserts').then(module => ({ default: module.FrostellaDesserts })));
const PrimeLearnAcademy = lazy(() => import('./pages/sub-companies/PrimeLearnAcademy').then(module => ({ default: module.PrimeLearnAcademy })));
const LabAtHome = lazy(() => import('./pages/sub-companies/LabAtHome').then(module => ({ default: module.LabAtHome })));

// Loading Fallback
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-neutral-50">
    <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
  </div>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/companies" element={<Companies />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

            {/* Sub Company Routes */}
            <Route
              path="/kalyan-agencies"
              element={<KalyanAgencies />}
            />
            <Route
              path="/frostella-pickles"
              element={<FrostellaPickles />}
            />
            <Route
              path="/frostella-desserts"
              element={<FrostellaDesserts />}
            />
            <Route
              path="/prime-learn-academy"
              element={<PrimeLearnAcademy />}
            />
            <Route
              path="/labathome"
              element={<LabAtHome />}
            />

            {/* 404 Fallback */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Layout>
    </Router>
  );
}

export default App;